import { LayerTypeId } from "@omnia/shared/generated/enums";
import { IDataLayer, ISeedRateLayer, ISeedRateLayerInfo, setDates } from "../exports";

export function loadSeedsLayers(layers: IDataLayer[]): IDataLayer[] {

    layers.forEach(layer => {

        if (layer.TypeId == LayerTypeId.SeedRate) {

            const seedsLayer = <ISeedRateLayer>layer;

            const info: ISeedRateLayerInfo = layer.LayerData;

            if (info) {

                setDates([info.Seeds], ["SowingDate", "CalculationDate"], false);

                seedsLayer.PlanId = info.PlanId
                seedsLayer.PlanUnit = info.PlanUnit
                seedsLayer.PlanName = info.PlanName
                seedsLayer.UseFlatRate = info.UseFlatRate
                seedsLayer.UseHeadland = info.UseHeadland
                seedsLayer.PlanMinRate = info.PlanMinRate
                seedsLayer.PlanMaxRate = info.PlanMaxRate
                seedsLayer.Seeds = info.Seeds
                seedsLayer.CropId = info.CropId

                if (seedsLayer.UseFlatRate && (!seedsLayer.Seeds.TGW)) {
                    seedsLayer.Seeds.TGW = 100
                }

            }


        }

    });

    return layers;

}
